"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationType = void 0;
var DurationType;
(function (DurationType) {
    DurationType["DAY"] = "days";
    DurationType["WEEK"] = "weeks";
    DurationType["MONTH"] = "months";
})(DurationType = exports.DurationType || (exports.DurationType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHVyYXRpb24tdHlwZS1lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbW1vbi9lbnVtcy9kdXJhdGlvbi10eXBlLWVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUgsSUFBWSxZQUlYO0FBSkQsV0FBWSxZQUFZO0lBQ3RCLDRCQUFZLENBQUE7SUFDWiw4QkFBYyxDQUFBO0lBQ2QsZ0NBQWdCLENBQUE7QUFDbEIsQ0FBQyxFQUpXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBSXZCIn0=